import { BLOCK_CLASSES as t } from "../../constants.js";
import { stylable as r } from "../decorators/stylable.js";
const a = r({
  content: "",
  group: "block",
  attrs: {
    type: { default: "horizontalRule" },
    width: { default: "" }
  },
  parseDOM: [
    {
      tag: "hr"
    }
  ],
  toDOM(o) {
    return [
      "div",
      {
        class: `${t.divider} intercom-divider-container`
      },
      ["div", ["hr"]]
    ];
  }
});
export {
  a as horizontalRuleSpec
};
